import type { Ref } from 'vue';
import type { HekateDisplayForm } from '@onshape/www-inertia';
import type UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import type UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';
import AbstractSignupScreenWithNewsletterForm from './AbstractSignupScreenWithNewsletterForm';

export default class SignupSuccessSignupScreen extends AbstractSignupScreenWithNewsletterForm {
  public readonly screenName: UnifiedSignupScreenName = 'uss-signup-success';

  constructor({
    sessionInfo,
    formDefinition,
    isBackButtonHidden,
    signupSurveyDiv,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>;
    formDefinition: Ref<HekateDisplayForm>;
    isBackButtonHidden: Ref<boolean>;
    signupSurveyDiv: HTMLDivElement | null;
  }) {
    super({
      formDefinition,
      isBackButtonHidden,
      sessionInfo,
      signupSurveyDiv,
    });
  }

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return this.getVisibleComponents();
  }

  public predicate(): boolean {
    const { emailStatus } = this.sessionInfo.value;
    if (emailStatus !== 'DELIVERED' && emailStatus !== 'VERIFIED') {
      return false;
    }

    return true;
  }

  public async toNextScreen(): Promise<boolean> {
    this.sessionInfo.value.completedDetailsScreens.push(this.screenName);
    return true;
  }

  public getProgress(): number {
    return 100;
  }
}
